import { matchPath } from 'react-router-dom';
import { SETTINGS_AREAS } from '@/features/settings/settingsNavigation';
import { navSections } from './navigation';

// Specific routes precede their navigation parents. Never use raw URLs as titles:
// authentication paths and scanner links can contain private tokens.
const routeTitles: ReadonlyArray<readonly [string, string]> = [
  ['/sign-in/*', 'Sign In'],
  ['/sign-up/*', 'Sign Up'],
  ['/invite/:token', 'Accept Invitation'],
  ['/research/mobile-scan', 'Mobile Scanner'],
  ['/research/new', 'New Research Scan'],
  ['/research/upload', 'New Research Scan'],
  ['/research/live', 'Live Scanner'],
  ['/research/:id', 'Research Scan'],
  ['/restock/supplier-mapping', 'Supplier Mapping'],
  ['/restock/pos/create', 'Create Purchase Order'],
  ['/restock/pos/:id', 'Purchase Order'],
  ['/workflows/draft-shipments/new', 'New Draft Shipment'],
  ['/workflows/draft-shipments/:id', 'Draft Shipment'],
  ['/workflows/working-shipments/plan/:planId/master', 'Master Shipment'],
  ['/workflows/working-shipments/plan/:planId/destination/:shipmentId', 'Destination'],
  ['/workflows/working-shipments/plan/:planId', 'Working Shipment'],
  ['/workflows/shipped/fba/plan/:planId/destination/:shipmentId', 'Shipped Destination'],
  ['/workflows/shipped/fba/plan/:planId', 'Shipped Shipment'],
  ['/workflows/shipped/fba', 'Shipped to Amazon'],
  ['/workflows/shipped/freight/*', 'Customer Freight'],
  ['/workflows/labels', 'Labels'],
  ['/workflows/builder', 'New Draft Shipment'],
  ['/workflows/master/*', 'Master Shipment'],
  ['/workflows/working-shipments/:id', 'Working Shipment'],
  ['/workflows/shipped/:id', 'Shipped Shipment'],
  ['/shipping/outbound/*', 'Customer Freight'],
  ['/restock', 'Restock Suggestions'],
  ['/restock/opportunities', 'Research Scans'],
  ['/repricer', 'Repricer Listings'],
  ['/workflows', 'Draft FBA Shipments'],
  ['/solicitations/campaigns/new', 'New Campaign'],
  ['/solicitations/campaigns/:id', 'Campaign'],
  ['/alerts', 'Alerts'],
  ['/analytics/sku/:sku', 'SKU Analytics'],
  ['/settings/stores/connect/success', 'Store Connected'],
  ['/settings/stores/connect/error', 'Store Connection Error'],
  ['/settings/stores/connect/amazon-login', 'Connect Amazon Store'],
  ...Object.values(SETTINGS_AREAS).flatMap(area => {
    const title = area.title.replace(/\bsettings\b/i, 'Settings');
    return [
      ...area.tabs.map(tab => [`/settings/${area.id}/${tab.path}`, `${title}: ${tab.label}`] as const),
      [`/settings/${area.id}`, title] as const,
    ];
  }),
  ['/settings/*', 'Settings'],
  ...navSections.flatMap(section => [
    ...(section.href ? [[section.href, section.bookmarkLabel ?? section.label] as const] : []),
    ...section.items.map(item => [item.href, item.bookmarkLabel] as const),
  ]),
];

export function getRouteTitle(pathname: string): string {
  return routeTitles.find(([path]) => matchPath(path, pathname))?.[1] ?? 'Zeroth';
}

export function namedPageTitle(prefix: string, name: string | null | undefined): string | undefined {
  const normalized = name?.replace(/\s+/g, ' ').trim();
  return normalized ? `${prefix}: ${normalized}` : undefined;
}
